// extracted by mini-css-extract-plugin
export default {"tags__list":"styles_tags__list__c0eRw"};